import React from "react";
import { Grid } from "@material-ui/core";
import { CustomBox } from "components/Box/CustomBox";
import { CustomerInfo } from "./accounts/CustomerInfo";
import { CustomerAccounts } from "./accounts/CustomerAccounts";
import { CustomerCycles } from "./cycles/CustomerCycles";
import { height } from "./CustomerView";
import { animations } from "helpers/animations";
import { CustomerConditions } from "./conditions/CustomerConditions";
import { CustomerDocs } from "./contracts/CustomerDocs";
import { useSelector } from "react-redux";
import { CustomerCreditConditions } from "./creditConditions/CustomerCreditConditions";
import { CustomerIotDevices } from "./CustomerIotDevices";
const cycleRule = 'CUSTOMER-CYCLES';
const conditionRule = 'CUSTOMER-COMMERCIAL';
const documentationRule = 'CUSTOMER-DOCUMENTATION';

export const GeneralInfoColumn = () => {
  const { rules } = useSelector(({login}) => login)
  return (
    <Grid item xs={12} md={4} lg={2} className={animations.fadeLeft} style={{
      animationDelay: ".7s",
    }}>
      <CustomBox title="Información General" style={{ height, overflowY: 'scroll' }}>
        <CustomerInfo />
        <CustomerAccounts />
        { rules.includes(cycleRule) ? <CustomerCycles /> : null}
        { rules.includes(conditionRule) ? <CustomerCreditConditions /> : null}
        { rules.includes(conditionRule) ? <CustomerConditions /> : null}
        { rules.includes(documentationRule) ? <CustomerDocs /> : null}
        <CustomerIotDevices /> 
      </CustomBox>
    </Grid>
  );
};
